<template>
    <b-modal
            :visible="show"
            @hidden="hideEvents"
            title="Tag Actions"
            :id="modalId"
    >
        <vue-element-loading :active="loading" :is-full-screen="false"/>
        <b-form>
            <b-form-group
                    label="Tags"
            >
            <tag-select
                ref="tagSelect"
                v-model="value"
            >
            </tag-select>
            </b-form-group>
        </b-form>
        <template slot="modal-footer">
            <b-button
                    variant="outline-secondary"
                    @click="hideModal">
                Cancel
                <font-awesome-icon
                        :icon="['far', 'times']">
                </font-awesome-icon>
            </b-button>
            <b-button
                    class="btn-arrow"
                    variant="primary"
                    @click="tagActions"
                    :disabled="tagDisabled"
            >
                Tag items
                <font-awesome-icon
                        :icon="['far', 'arrow-right']">
                </font-awesome-icon>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import TagSelect from '@/components/Form/TagSelect';
import ModalMixin from '@/components/Modal/ModalMixin';

export default {
  name: 'Tag-Modal',
  components: {
    TagSelect,
  },
  mixins: [ModalMixin],
  data() {
    return {
      modalId: 'tagModal',
      loading: false,
      value: [],
    };
  },
  computed: {
    tagDisabled() {
      return (this.nodeIds.length === 0 || this.value.length === 0) || this.loading;
    },
  },
  mounted() {
    this.$store.dispatch('refreshTags');
  },
  methods: {

    async tagActions() {
      if (this.nodeIds.length === 0 || !this.validate()) {
        return;
      }

      this.loading = true;

      const tags = this.value.map(tag => tag.name);

      try {
        await this.$store.dispatch('updateTags', { clientActionIds: this.nodeIds, tags });

        this.$notify({
          title: 'Success',
          text: `All ${this.nodeIds.length} actions have been tagged.`,
          type: 'success',
        });
        this.$store.dispatch('refreshActions');
        this.$store.dispatch('refreshTags');
      } catch (e) {
        this.$notify({
          title: 'Error',
          text: 'Something went wrong. Please try again later.',
          type: 'error',
        });
      } finally {
        this.hideModal();
      }
    },

    validate() {
      if (this.value.length === 0) {
        this.$notify({
          title: 'Error',
          text: 'Please select or create a tag',
          type: 'error',
        });
        return false;
      }
      return true;
    },

    hideModalEvents() {
      this.value = [];
    },
  },
};
</script>

<style lang="scss">
.modal {
  .btn.btn-arrow {
    min-width: 140px;
  }

  .btn-outline-secondary + .btn-arrow {
    margin: auto;
    margin-right: 0;
  }
}
</style>
